import { useCallback } from 'react';
import useAppDispatch from 'js/hooks/useAppDispatch';
import {
  setRecipeGroups as setRecipeGroupsAction,
  setExpandedRecipeGroup as setExpandedRecipeGroupAction,
} from 'js/actions';
import { UpdateRecipeGroups, UseRecipeBuilderAdapter, ExpandRecipeGroup } from '../types';

export default function useRecipeBuilderAdapter(): UseRecipeBuilderAdapter {
  const dispatch = useAppDispatch();

  const updateRecipeGroups: UpdateRecipeGroups = useCallback(
    (recipeGroups, isRecipeUnapplied, autoApply) => {
      const thunk = setRecipeGroupsAction(recipeGroups, isRecipeUnapplied, autoApply);

      dispatch(thunk);
    },
    [],
  );

  const expandRecipeGroup: ExpandRecipeGroup = useCallback((index: number) => {
    const thunk = setExpandedRecipeGroupAction(index);
    dispatch(thunk);
  }, []);

  return { updateRecipeGroups, expandRecipeGroup };
}
